import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, Timestamp } from "firebase/firestore";
import { db } from "../../../../firebase";
import { Navbar } from "../../../../Components/Navbar/Navbar";
import { Footer } from "../../../../Components/Footer/footer";
import { PressMediaLink, PressLink } from "../linkEmbed";
import "./style.css";

interface PressRelease {
  id: string;
  title: string;
  content: string;
  date: Timestamp;
  image_url?: string;
  links?: PressLink[];
}

export function ComunicatPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [release, setRelease] = useState<PressRelease | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!id) return;
      const docRef = doc(db, "press_releases", id);
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        setRelease({ id: snap.id, ...(snap.data() as any) } as PressRelease);
      } else {
        setRelease(null);
      }
    };
    fetchData();
  }, [id]);

  if (!release) {
    return (
      <div className="page-container">
        <Navbar />
        <div className="page-content">
          <h1>Comunicatul nu a fost găsit</h1>
          <button onClick={() => navigate(-1)}>Înapoi</button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="page-container">
      <Navbar />
      <div className="page-content">
        <button className="back-button" onClick={() => navigate(-1)}>
          ← Înapoi
        </button>

        {release.image_url && (
          <img
            src={release.image_url}
            alt="Imagine comunicat"
            className="press-banner-img"
          />
        )}

        <h1>{release.title}</h1>
        <p className="press-date">
          {release.date?.toDate?.().toLocaleDateString("ro-RO", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </p>

        <div className="press-content">{release.content}</div>

        {release.links && release.links.length > 0 && (
          <div className="press-links">
            {release.links.map((link) => (
              <PressMediaLink key={link.id} link={link} />
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
